import React, { Component } from "react";
import { inject, observer } from "mobx-react"
import { Provider } from "mobx-react"
import { Icon, Switch } from 'antd'
import EventCards from '../../layoutComponents/EventCards'
import OracleEventCards from  '../../layoutComponents/OracleEventCards'


@inject("web3Store")
@inject("eventStore")
@inject("ViewStore")
@inject("CategoriesStore", "TeamStore", "AdminStore")
@observer class ExpiredEvents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            featuredTeamList: [],
            showDefault: true,
            eventList: [],
            eventsChecked: false
       
        };

        const { eventStore } = this.props;
        eventStore.queryEvents();
        this.switchChange = this.switchChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.renderExpiredEvents = this.renderExpiredEvents.bind(this);
    }

    switchChange(checked) {
        this.setState({ showDefault: checked });
    }

    async componentWillMount() {
        this.props.ViewStore.changeView('Expired Events');

        const { TeamStore } = this.props;
        let teamList = [];
        TeamStore.queryTeams().then(async () => {
            setTimeout(() => {
                this.setState({ teams: Array.from(TeamStore.teams.values()) });
            }, 500)

        });

        // this.props.eventStore.querySingleEvent('0xf677b6ba1a5c317de0dae6dfa66d52f61a61f2f75d6da3295d2c559f4f94b1b8');


    }

    componentDidMount() {
        const { eventStore } = this.props;
        eventStore.queryEvents();
    }

    handleClick() {
        this.props.ViewStore.changeGridList()
    }

    renderEvent(event) {
        let time = new Date().getTime() / 1000;
        let startTime = new Date();
        startTime.setTime(event.startTime * 1000);
        let startTimeString = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();

        return (
            <EventCards
                key={event._id}
                event_id={event._id}
                bytes32_id={event.bytes32Id}
                start_time={startTimeString}
                team_one={event.teams[0]}
                team_two={event.teams[1]}
                event={event}
                expired={true} />
        );
    }


    renderEvents() {
        const { eventStore } = this.props;
        let eventList = [];

        for (let event of eventStore.events.values()) {
            eventList.push(this.renderEvent(event));
        }
        return eventList;
    }
    renderExpiredEvents() {
        const { eventStore, AdminStore } = this.props;
        let eventList = this.state.eventList;     
        let timeNow = new Date().getTime()/1000;
        console.log('Time now:' + timeNow);
        if (eventList.length == 0 && !this.state.eventsChecked) {
            for (let event of eventStore.events.values()) {
                if (event.startTime + event.duration + Number(AdminStore.oraclePeriod) < timeNow) {
                    if (!event.cancelled && !event.finalized) {
                        eventList.push(this.renderEvent(event));
                    }
                }      
            }
            this.setState({ eventList: eventList, eventsChecked : true });
            return (eventList.length > 0 ? eventList : <div className="my-bets-page-cards-bet-options-title">
            <Icon style={{padding:10, fontSize: "30px"}} type="calendar" /><h3>No Expired Events Found</h3>
        </div>);
        } else {
            return (eventList.length > 0 ? eventList : <div className="my-bets-page-cards-bet-options-title">
            <Icon style={{padding:10, fontSize: "30px"}} type="calendar" /><h3>No Expired Events Found</h3>
        </div>);
        }

    }
 
    render() {
        let gridColumnEvents = "";
        let gridListIcon = "";

        if (this.props.ViewStore.getHeaderState === true) {
            gridColumnEvents = '100%';

        } else {
            if (this.props.ViewStore.getGridList === "list") {
                gridListIcon = <Icon type="appstore" onClick={this.handleClick} />
                gridColumnEvents = '100%';
            } else {
                gridListIcon = <Icon type="bars" onClick={this.handleClick} />
                gridColumnEvents = '49.2% 49.2%';
            }
        }

        const { eventStore } = this.props;

        return (
            <Provider>
                <div className="featured-events-wrap">
                    <div className="view-options">                      
                        <div className="grid-list-icon">{gridListIcon}</div>
                    </div>
                    <div className="main-page-cards" style={{ gridTemplateColumns: gridColumnEvents }}>
                        {
                            eventStore.getEventCount() > 0
                                ? this.renderExpiredEvents()
                                : (eventStore.isLoading() ? "Looking for events..." : "No events found.")
                         
                        }
                    </div>
                </div>
            </Provider>
        );
    }
}

export default ExpiredEvents;



// WEBPACK FOOTER //
// ./src/components/appComponents/events/ExpiredEvents.js